module.exports = "https://coursera_assets.s3.amazonaws.com/images/203e82f2e69460315e57fe458ca48201.png";